import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  store
    .dispatch('rooms/fetch', { property: routeTo.params.permalink })
    .then(() => next())
    .catch(() => next()) // 500 - internal server error
}
